import { GraphQL, GraphQLPagedQueryData } from "@rpi/openapi-api";
import { RpiTableColumns } from "../../rpi-core/table/RpiTable";
import { createEntityColumn } from "../../rpi-core/table/RpiTableHelpers";
import { CellDate } from "../../components/cells/CellDate";
import { CellStatusV2 } from "../../components/cells/CellStatusV2";
import { formatCurrency } from "../../utils/misc.util";

const orderColumn = createEntityColumn<GraphQL.OrderResponse, GraphQL.OrderSearchField>();

const baseOrderColumnDefs = {
  orderDate: orderColumn<"createdAt">({
    header: "Order Date",
    accessor: "createdAt",
    cell: ({ row }) => <CellDate date={row.createdAt} format="MM/DD/YYYY" />,
    sortKey: GraphQL.OrderSearchField.CreatedAt,
    size: 170,
  }),
  orderNumber: orderColumn<"id">({
    header: "Order#",
    accessor: "id",
    size: 90,
    minSize: 80,
  }),
  organization: orderColumn<"customer">({
    header: "Organization",
    accessor: "customer",
    cell: ({ row }) => row.customer?.publicId || "—", // Use publicId since organizationName may not be in the query
    size: 170,
  }),
  orderStatus: orderColumn<"publicOrderStatus">({
    header: "Order Status",
    accessor: "publicOrderStatus",
    cell: ({ row }) => <CellStatusV2.PublicOrder status={row.publicOrderStatus} />,
    size: 170,
  }),
  orderStatusMessage: orderColumn<"lastStatusMessage">({
    header: "Status Message",
    accessor: "lastStatusMessage",
    cell: ({ row }) => row.lastStatusMessage?.trim() || "—",
    size: 170,
  }),
  orderStatusUpdatedDate: orderColumn<"updatedAt">({
    header: "Status Updated Date",
    accessor: "updatedAt",
    cell: ({ row }) => <CellDate date={row.updatedAt} format="MM/DD/YYYY" />,
    size: 170,
    sortKey: GraphQL.OrderSearchField.UpdatedAt,
  }),
  orderPaymentSubmittedDate: orderColumn<"submittedAt">({
    header: "Submitted Date",
    accessor: "submittedAt",
    cell: ({ row }) => (row.submittedAt ? <CellDate date={row.submittedAt} format="MM/DD/YYYY" /> : "-"),
    size: 170,
    sortKey: GraphQL.OrderSearchField.SubmittedAt,
  }),
  orderPaymentAmount: orderColumn<"pricing" | "currency">({
    header: "Amount",
    accessor: "pricing",
    cell: ({ row }) => formatCurrency(row.currency, row.pricing?.orderTotal || 0),
    size: 90,
    minSize: 82,
  }),

  orderPaymentStatus: orderColumn<"paymentStatus">({
    header: "Payment Status",
    accessor: "paymentStatus",
    cell: ({ row }) => <CellStatusV2.Payment status={row.paymentStatus} />,
    size: 100,
    minSize: 90,
  }),
};

export const orderColumnsV2: RpiTableColumns<GraphQLPagedQueryData<GraphQL.OrdersQuery>> = (user) => [
  baseOrderColumnDefs.orderDate,
  baseOrderColumnDefs.orderNumber,
  user.is.SUPER_ADMIN && baseOrderColumnDefs.organization,
  baseOrderColumnDefs.orderStatus,
  baseOrderColumnDefs.orderStatusMessage,
  baseOrderColumnDefs.orderStatusUpdatedDate,
  !user.isSandbox && user.is.SUPER_ADMIN && baseOrderColumnDefs.orderPaymentSubmittedDate,
  !user.isSandbox && baseOrderColumnDefs.orderPaymentAmount,
  !user.isSandbox && baseOrderColumnDefs.orderPaymentStatus,
];
